import { useState } from 'react'
import { openCustomerInvoicePdf, type CustomerOrderInvoice } from '../customerOrdersApi'
import type { ShopMessageKey } from '../../i18n'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

export const useCustomerInvoiceOpener = ({
  token,
  t,
}: {
  token: string | null
  t: TranslateFn
}) => {
  const [invoiceOpeningId, setInvoiceOpeningId] = useState<string | null>(null)
  const [invoiceOpenError, setInvoiceOpenError] = useState('')

  const handleOpenInvoice = async (invoice: CustomerOrderInvoice) => {
    setInvoiceOpeningId(invoice.id)
    setInvoiceOpenError('')

    try {
      await openCustomerInvoicePdf(token, invoice)
    } catch (error) {
      const message =
        error instanceof Error && error.message.trim()
          ? error.message
          : t('customer.orderDetail.openInvoiceError')
      setInvoiceOpenError(message)
    } finally {
      setInvoiceOpeningId((current) => (current === invoice.id ? null : current))
    }
  }

  return {
    invoiceOpeningId,
    invoiceOpenError,
    handleOpenInvoice,
  }
}
